import * as Button from '@alifd/next/lib/button';
import * as Dialog from '@alifd/next/lib/dialog';
import * as Balloon from '@alifd/next/lib/balloon';
import * as Icon from '@alifd/next/lib/icon';
import * as Breadcrumb from '@alifd/next/lib/breadcrumb';
import * as Loading from '@alifd/next/lib/loading';
import * as Message from '@alifd/next/lib/message';
import * as Slider from '@alifd/next/lib/slider';
import * as Tab from '@alifd/next/lib/tab';
import * as Radio from '@alifd/next/lib/radio';
import * as NumberPicker from '@alifd/next/lib/number-picker';

import * as ReactRedux from 'react-redux';

import './screen.scss';

( window as any ).ReactRedux = ReactRedux;

export {
    Button,
    Dialog,
    Breadcrumb,
    Slider,
    Radio,
    Tab,
    NumberPicker,
    Message,
    Balloon,
    Loading,
    Icon
};